export default {
  peopleSearch: 'PeopleSearch',
  googleCalendar: 'GoogleCalendar',
  mayoForm: 'MAYOForm',
  standardProcessesByRoles: [
    'TAModuleAdmin',
    'TAAdmin',
    'OMAdmin',
    'HireManager',
    'PAModifier',
    'UltimateAdmin',
    'PYModuleAdmin',
    'Declaration',
    'Insurance',
    'Salary',
  ],
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/configs/functions.js
 **/